import {Stack, Typography, styled, css} from '@mui/material';
import {ContainerProps} from '../types';

const Container = styled(Stack)<ContainerProps>`
	padding: 16px;
	width: 100%;
	cursor: grab;
	background-color: ${({theme, $isOnDrop}) =>
		$isOnDrop ? theme.colors.light.primary['08Percent'] : theme.colors.gray['10Percent']};
	border-radius: 4px;
	border: 1px dashed
		${({theme, $isOnDrop}) =>
			$isOnDrop ? theme.palette.primary.light : theme.colors.light.other.border};

	${({theme, $isError}) =>
		$isError &&
		css`
			border: 1px solid ${theme.colors.light.error.main};
		`}
`;

const Label = styled(Typography)`
	text-align: center;
	color: ${({theme}) => theme.colors.light.primary.main};
	border-bottom: 1px solid ${({theme}) => theme.colors.light.primary.main};
	cursor: pointer;
`;

const FileInput = styled('input')`
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	z-index: -1;
`;

export {Container, Label, FileInput};
